import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import Flash from "../flash/Flash.jsx"
import { ThirdPartyApiNameByValue } from '../../repo/ThirdPartyApiRepo'

export default function AdminTeamsShow({team, status}) {
  const [flashMessage, setFlashMessage] = useState("")

  useEffect(() => {
    if (status === "created") {
      setFlashMessage("Team was successfully created")
    } else if (status === "updated") {
      setFlashMessage("Team was successfully updated")
    }

    window.history.replaceState(null, "Admin - Team" , '/cocofantoelefanto/teams/' + team.id)
  }, [team.id, status])

  return(
    <>
      <h1>Show Team</h1>
      {flashMessage !== "" && (
        <Flash message={flashMessage} type="success"/>
      )}

      <div className="flex flex-col mt-4">
        <div key="team_name">
          <b>Name:</b>
          <span className="ml-4">{ team.name }</span>
        </div>

        <div key="team_badge">
          <b>Escudo:</b>
          <img className="ml-4" src={team.badge_thumb} alt={team.name}/>
        </div>

        <div key="team_third_party_api">
          <b>API de terceiros:</b>
          <span className="ml-4">{ ThirdPartyApiNameByValue(team.third_party_label) }</span>
        </div>

        <div key="team_third_party_id">
          <b>ID de terceiros:</b>
          <span className="ml-4">{ team.third_party_id }</span>
        </div>
      </div>

      <div id="actions" className="w-full pt-4 mt-4 space-x-2">
        <Link className="hover:no-underline underline" to={`/cocofantoelefanto/teams/${team.id}/edit`}>Edit Team</Link>
        <span>|</span>
        <Link className="hover:no-underline underline" to="/cocofantoelefanto/teams">Back to Teams</Link>
        <span>|</span>
        <Link className="hover:no-underline underline" to="/cocofantoelefanto/teams/new">Create New Team</Link>
      </div>

    </>
  )
}
